import { Box } from '@web/components/atoms/Layout'
import {
  DESKTOP_CONTAINER_QUERY,
  MOBILE_CONTAINER_QUERY,
  PageComponentProps,
} from '@web/components/page-components/utils'
import { ComponentType } from '@web/graphql-components'
import React from 'react'
import { COMPONENTS } from './PageComponent'

const SubComponent = (props: PageComponentProps) => {
  const component = props.allComponents?.get(props.id)

  if (!component) {
    return null
  }

  return (
    <Box
      w={component.type === ComponentType.Text ? '100%' : 'fit-content'}
      css={{
        [MOBILE_CONTAINER_QUERY]: {
          display: component.mobileStyles?.display ?? 'block',
        },
        [DESKTOP_CONTAINER_QUERY]: {
          display: component.styles?.display ?? 'block',
        },
      }}
    >
      {React.createElement(COMPONENTS[component.type], {
        key: `${props.id}-component`,
        ...component,
        ...props,
      })}
    </Box>
  )
}

export default SubComponent
